import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Product from "./views/Product.vue";
import Login from "./views/Login.vue";
import Orders from "./views/Orders.vue";
import FindArdunic from "./views/FindArdunic.vue";
// import Blog from "./views/Blog.vue";
import Activation from "./views/Activation.vue";
import Cart from "./views/Cart.vue";
import Billing from "./views/Billing.vue";
import Profile from "./views/Profile.vue";
// import Learn from "./views/Learn.vue";
import ProductSearch from "./views/ProductSearch.vue";
import TagsSearch from "./views/TagsSearch.vue";
import SubCategories from "./views/SubCategories.vue";
import CategoryProducts from "./views/CategoryProducts.vue";
import Loading from "./views/Loading.vue";
// import Blogs from "./views/Blogs.vue";
import OrderDetail from "./views/OrderDetail.vue";
import OrderSuccess from "./views/OrderSuccess.vue";
import Tags from "./views/Tags.vue";
import Privacy from "./views/Privacy.vue";
import UnderConstruction from "./views/UnderConstruction.vue";
import PandP from "./views/PandP.vue";
import UserAgreement from "./views/UserAgreement.vue";
import Page404 from "./views/404.vue";

import Jobs from "./views/Jobs.vue";
import JobDetail from "./views/JobsDetail.vue";
Vue.use(Router);

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/product/:slug",
      name: "product",
      component: Product,
      // props: true
    },
    {
      path: "/search/:word/:page",
      name: "search",
      component: ProductSearch,
    },
    {
      path: "/tag/:id",
      name: "tags search",
      component: TagsSearch,
    },
    {
      path: "/privacy-and-policy",
      name: "p and p",
      component: PandP,
    },
    {
      path: "/user-agreement",
      name: "user agreement",
      component: UserAgreement,
    },
    {
      path: "/tags",
      name: "tags",
      component: Tags,
    },
    {
      path: "/jobs",
      name: "jobs",
      component: Jobs,
    },
    {
      path: "/jobs/:id",
      name: "job detail",
      component: JobDetail,
    },
    {
      path: "/loading",
      name: "loading",
      component: Loading,
    },
    {
      path: "/cart",
      name: "cart",
      component: Cart,
      meta: { requiresAuth: true },
    },
    {
      path: "/privacy",
      name: "privacy",
      component: Privacy,
    },
    {
      path: "/billing",
      name: "billing",
      component: Billing,
      meta: { requiresAuth: true },
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: { requiresAuth: true },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { requiresVisitor: true },
    },
    {
      path: "/account-activation",
      name: "activation",
      component: Activation,
      props: true,
      meta: { requiresVisitor: true },
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders,
      meta: { requiresAuth: true },
    },
    {
      path: "/order-success/:orderId",
      name: "order success",
      component: OrderSuccess,
      meta: { requiresAuth: true },
    },
    {
      path: "/orders/:id",
      name: "order detail",
      component: OrderDetail,
      meta: { requiresAuth: true },
    },
    {
      path: "/find-us",
      name: "find",
      component: FindArdunic,
    },
    {
      path: "/learn",
      name: "learn",
      component: UnderConstruction,
    },
    {
      path: "/blogs/:id",
      name: "blog",
      component: UnderConstruction,
    },
    {
      path: "/blogs",
      name: "blogs",
      component: UnderConstruction,
    },
    {
      path: "/sub/:name/:id",
      name: "sub-cat 2",
      component: SubCategories,
      props: true,
    },
    {
      path: "/sub/:parent_name/:name/:id/products",
      name: "sub-cat",
      component: CategoryProducts,
      props: true,
    },
    {
      path: "/shop",
      name: "shop",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Search.vue"),
    },
    {
      path: "/categories",
      name: "categories",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Categories.vue"),
    },
    {
      path: "*",
      name: "Page404",
      component: Page404,
    },
  ],
});
